/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Ai_Stage_OperateInputs */

const en_directory_detail_signals_ai_stage_operate = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_OperateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operate`)
};

const zh_directory_detail_signals_ai_stage_operate = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_OperateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作`)
};

/**
* | output |
* | --- |
* | "Operate" |
*
* @param {Directory_Detail_Signals_Ai_Stage_OperateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_ai_stage_operate = /** @type {((inputs?: Directory_Detail_Signals_Ai_Stage_OperateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Ai_Stage_OperateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_ai_stage_operate(inputs)
	return zh_directory_detail_signals_ai_stage_operate(inputs)
});
export { directory_detail_signals_ai_stage_operate as "directory.detail.signals.ai_stage.operate" }